export const HORDE_HASH = 'f0e7fe2e5f6039f1ad308588495b294ef65fde5b6d24e1610b07b91ef7e23cf0';
